function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Button, ButtonGroup, HStack, Stack, Box, Icon } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import SongRow from './SongRow';
import SearchInput from '../SearchInput';
import Panel from '../Panel';
import { TableHeader } from '../Table';
import EmptyState from '../EmptyState';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDebounce } from 'use-debounce';
import { Table as MantineTable } from '@mantine/core';
import TableHeading from '../TableHeading';
import tableStyles from '../Table.module.scss';
import styles from './SongRequestTable.module.scss';
function SongRequestDraggableList(param) {
    var songRequests = param.songRequests, dragPortalRef = param.dragPortalRef, onSongRequestDelete = param.onSongRequestDelete, onCheckCanDeleteSongRequest = param.onCheckCanDeleteSongRequest;
    return (songRequests !== null && songRequests !== void 0 ? songRequests : []).map(function(song, index) {
        return /*#__PURE__*/ _jsx(Draggable, {
            draggableId: song._id,
            index: index,
            children: function(provided, snapshot) {
                var _ref;
                return /*#__PURE__*/ _jsx(SongRow, {
                    song: song,
                    isDraggable: true,
                    provided: provided,
                    snapshot: snapshot,
                    portalRef: dragPortalRef,
                    onDelete: ((_ref = onSongRequestDelete != null || (onCheckCanDeleteSongRequest === null || onCheckCanDeleteSongRequest === void 0 ? void 0 : onCheckCanDeleteSongRequest(song))) !== null && _ref !== void 0 ? _ref : false) ? onSongRequestDelete : undefined
                }, song._id);
            }
        }, "".concat(song._id, "-container"));
    });
}
var MemoizedSongRequestDraggableList = /*#__PURE__*/ React.memo(SongRequestDraggableList, function(prev, next) {
    return prev.songRequests === next.songRequests;
});
function SongRequestPlaylistList(param) {
    var playlist = param.playlist, onPlaylistItemDelete = param.onPlaylistItemDelete;
    return (playlist !== null && playlist !== void 0 ? playlist : []).map(function(song) {
        return /*#__PURE__*/ _jsx(SongRow, {
            song: song,
            opacity: 'user' in song ? 1 : 0.75,
            onDelete: onPlaylistItemDelete
        }, song._id);
    });
}
var MemoizedSongRequestPlaylistList = /*#__PURE__*/ React.memo(SongRequestPlaylistList, function(prev, next) {
    return prev.playlist === next.playlist;
});
function SongRequestSearchList(param) {
    var songs = param.songs, onSongRequestDelete = param.onSongRequestDelete, onCheckCanDeleteSongRequest = param.onCheckCanDeleteSongRequest;
    return (songs !== null && songs !== void 0 ? songs : []).map(function(song) {
        var _ref;
        return /*#__PURE__*/ _jsx(SongRow, {
            song: song,
            onDelete: ((_ref = onSongRequestDelete != null || (onCheckCanDeleteSongRequest === null || onCheckCanDeleteSongRequest === void 0 ? void 0 : onCheckCanDeleteSongRequest(song))) !== null && _ref !== void 0 ? _ref : false) ? onSongRequestDelete : undefined
        }, song._id);
    });
}
var MemoizedSongRequestSearchList = /*#__PURE__*/ React.memo(SongRequestSearchList, function(prev, next) {
    return prev.songs === next.songs;
});
function PlaylistSeperator() {
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(TableHeading, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "bv2dU7",
                    defaultMessage: "Playlist"
                })
            }),
            /*#__PURE__*/ _jsx(Icon, {
                as: FontAwesomeIcon,
                icon: faPencil,
                color: "textSecondary",
                marginLeft: 2,
                display: "none",
                _groupHover: {
                    display: 'inline'
                }
            })
        ]
    });
}
var MemoizedPlaylistSeperator = /*#__PURE__*/ React.memo(PlaylistSeperator);
function SongRequests(param) {
    var beforeControlsElement = param.beforeControlsElement, afterControlsElement = param.afterControlsElement, songRequests = param.songRequests, playlist = param.playlist, dragPortalRef = param.dragPortalRef, _param_isDraggable = param.isDraggable, isDraggable = _param_isDraggable === void 0 ? false : _param_isDraggable, tablePanelProps = param.tablePanelProps, onSongRequestDelete = param.onSongRequestDelete, onCheckCanDeleteSongRequest = param.onCheckCanDeleteSongRequest, onPlaylistItemDelete = param.onPlaylistItemDelete, handleDragEnd = param.handleDragEnd, onAddSongRequest = param.onAddSongRequest;
    var _React_useState = _sliced_to_array(React.useState(''), 2), search = _React_useState[0], setSearch = _React_useState[1];
    var _useDebounce = _sliced_to_array(useDebounce(search, 300), 1), debouncedSearch = _useDebounce[0];
    var intl = useIntl();
    var hasQuery = search.length > 0;
    var filteredSongRequests = React.useMemo(function() {
        if (songRequests == null) {
            return null;
        }
        var normalizedQuery = debouncedSearch.toLowerCase();
        return normalizedQuery.length > 0 ? songRequests.filter(function(request) {
            var _request_track_title, _request_track, _request_track_artist, _request_track1, _request_user_displayName, _request_user;
            return ((_request_track = request.track) === null || _request_track === void 0 ? void 0 : (_request_track_title = _request_track.title) === null || _request_track_title === void 0 ? void 0 : _request_track_title.toLowerCase().includes(normalizedQuery)) || ((_request_track1 = request.track) === null || _request_track1 === void 0 ? void 0 : (_request_track_artist = _request_track1.artist) === null || _request_track_artist === void 0 ? void 0 : _request_track_artist.toLowerCase().includes(normalizedQuery)) || ((_request_user = request.user) === null || _request_user === void 0 ? void 0 : (_request_user_displayName = _request_user.displayName) === null || _request_user_displayName === void 0 ? void 0 : _request_user_displayName.toLowerCase().includes(normalizedQuery));
        }) : songRequests;
    }, [
        debouncedSearch,
        songRequests
    ]);
    var showQueue = isDraggable && !hasQuery;
    var showSeperator = playlist != null && playlist.length > 0 && songRequests != null && songRequests.length > 0;
    var showEmpty = (songRequests == null || songRequests.length === 0) && (playlist == null || playlist.length === 0);
    return /*#__PURE__*/ _jsxs(Stack, {
        gap: 6,
        flex: 1,
        children: [
            /*#__PURE__*/ _jsxs(HStack, {
                justifyContent: "space-between",
                display: {
                    base: 'none',
                    sm: 'flex'
                },
                children: [
                    /*#__PURE__*/ _jsxs(ButtonGroup, {
                        spacing: 6,
                        size: "sm",
                        variant: "outline",
                        children: [
                            beforeControlsElement,
                            /*#__PURE__*/ _jsx(SearchInput, {
                                placeholder: intl.formatMessage({
                                    id: "sAUf2i",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Search queue..."
                                        }
                                    ]
                                }),
                                setSearch: setSearch,
                                search: search,
                                display: {
                                    base: 'none',
                                    md: 'block'
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(ButtonGroup, {
                        spacing: 6,
                        size: "sm",
                        variant: "outline",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                marginLeft: "auto",
                                variant: "cta",
                                onClick: onAddSongRequest,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "AcTvIK",
                                    defaultMessage: "Request Song"
                                })
                            }),
                            afterControlsElement
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                display: {
                    base: 'flex',
                    sm: 'none'
                },
                children: beforeControlsElement
            }),
            /*#__PURE__*/ _jsxs(ButtonGroup, {
                gap: 4,
                size: "sm",
                display: {
                    base: 'flex',
                    sm: 'none'
                },
                children: [
                    /*#__PURE__*/ _jsx(SearchInput, {
                        flex: 1,
                        placeholder: intl.formatMessage({
                            id: "sAUf2i",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Search queue..."
                                }
                            ]
                        }),
                        setSearch: setSearch,
                        search: search
                    }),
                    afterControlsElement
                ]
            }),
            showEmpty ? /*#__PURE__*/ _jsx(Panel, _object_spread_props(_object_spread({
                display: "grid",
                placeItems: "center",
                overflow: "hidden",
                borderStyle: "dashed",
                borderColor: "borderPrimary",
                paddingY: 10,
                paddingX: 0
            }, tablePanelProps), {
                children: /*#__PURE__*/ _jsx(EmptyState, {
                    title: intl.formatMessage({
                        id: "rAONUi",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "No songs in the queue"
                            }
                        ]
                    }),
                    description: intl.formatMessage({
                        id: "jNIpTO",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Request a song to get started!"
                            }
                        ]
                    }),
                    buttons: [
                        /*#__PURE__*/ _jsx(Button, {
                            onClick: onAddSongRequest,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "AcTvIK",
                                defaultMessage: "Request Song"
                            })
                        }, "request-song")
                    ]
                })
            })) : /*#__PURE__*/ _jsx(Panel, _object_spread_props(_object_spread({
                className: tableStyles.panel
            }, tablePanelProps), {
                children: /*#__PURE__*/ _jsxs(MantineTable, {
                    className: tableStyles.table,
                    children: [
                        /*#__PURE__*/ _jsx(TableHeader, {
                            children: /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                                children: [
                                    /*#__PURE__*/ _jsx(TableHeading, {
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: "IpkirO",
                                            defaultMessage: "Up Next"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(TableHeading, {
                                        className: styles.actionsHeader,
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: "Mud4xW",
                                            defaultMessage: "Added By"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(TableHeading, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DragDropContext, {
                            onDragEnd: function(result) {
                                return handleDragEnd === null || handleDragEnd === void 0 ? void 0 : handleDragEnd(result);
                            },
                            children: /*#__PURE__*/ _jsx(Droppable, {
                                droppableId: "songRequests",
                                children: function(provided) {
                                    return /*#__PURE__*/ _jsx(MantineTable.Tbody, _object_spread_props(_object_spread({}, provided.droppableProps), {
                                        ref: provided.innerRef,
                                        children: showQueue ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(MemoizedSongRequestDraggableList, {
                                                    songRequests: songRequests,
                                                    dragPortalRef: dragPortalRef,
                                                    onSongRequestDelete: onSongRequestDelete,
                                                    onCheckCanDeleteSongRequest: onCheckCanDeleteSongRequest
                                                }),
                                                provided.placeholder,
                                                showSeperator ? /*#__PURE__*/ _jsx(MemoizedPlaylistSeperator, {}) : null,
                                                /*#__PURE__*/ _jsx(MemoizedSongRequestPlaylistList, {
                                                    playlist: playlist,
                                                    onPlaylistItemDelete: onPlaylistItemDelete
                                                })
                                            ]
                                        }) : /*#__PURE__*/ _jsx(MemoizedSongRequestSearchList, {
                                            songs: filteredSongRequests,
                                            onSongRequestDelete: onSongRequestDelete,
                                            onCheckCanDeleteSongRequest: onCheckCanDeleteSongRequest
                                        })
                                    }));
                                }
                            })
                        })
                    ]
                })
            }))
        ]
    });
}
export default /*#__PURE__*/ React.memo(SongRequests, function(prev, next) {
    return prev.songRequests === next.songRequests && prev.playlist === next.playlist && prev.isDraggable === next.isDraggable && prev.tablePanelProps === next.tablePanelProps;
});
